<template>
  <Panel class="intro-y" :title="$t('text.customerStatusHistory')">
    <div v-if="customer.contractStartDate" class="flex flex-col sm:flex-row">
      <p class="mr-3 text-gray-600">{{ $t('text.customerInfoContractStartDate') }}:</p>
      <p class="font-medium">
        {{ customer.contractStartDate }}
      </p>
    </div>
    <div v-if="customer.contractEndDate" class="flex flex-col sm:flex-row">
      <p class="mr-3 text-gray-600">{{ $t('text.customerInfoContractEndDate') }}:</p>
      <p class="font-medium">
        {{ customer.contractEndDate }}
      </p>
    </div>

    <hr v-if="hasDivider" class="my-3" />

    <div
      v-for="(item, index) in customer.histories"
      :key="index"
      :class="['flex flex-col sm:flex-row', { 'mt-5': index > 0 }]"
    >
      <p class="mr-auto text-gray-600">{{ item.status | customerStatusToVerb }}</p>
      <p class="font-medium">{{ item.createdAt | momentDate('YYYY-MM-DD HH:mm:ss') }}</p>
    </div>
  </Panel>
</template>

<script>
import Panel from '@/components/ui/Panel';

export default {
  props: {
    customer: Object,
  },

  computed: {
    hasDivider() {
      return !!(
        (this.customer.contractStartDate || this.customer.contractEndDate) &&
        this.customer.histories.length > 0
      );
    },
  },

  components: { Panel },
};
</script>
